import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import { ContributorJob } from 'src/app/models/contributor-jobs.model';
import { of, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContributorJobsService {

  cache = [];

  constructor(
    private api: ApiService
  ) { }

  getDefaultJobs() {
    return this.api.get<ContributorJob[]>(`contributors/default_jobs`).pipe(map(_a => _a.payload));
  }

  getEntityJobs(entityID: number, type: string): Observable<ContributorJob[]> {
    const cached = this.cache[`${entityID}_${type}`];
    if (cached) {
      return of(cached.payload);
    }

    return this.api.get<ContributorJob[]>(`entity/${entityID}/jobs`).pipe(
      map(_a => {
        this.cache[`${entityID}_${type}`] = _a;
        return _a.payload;
      })
    );
  }


}
